export const vehiclesPatternConstants = {
  NAME_PATTERN: /^.{1,100}$/,
  REF_PATTERN: /^.{1,100}$/,
  VIN_PATTERN: /^.{1,100}$/,
  NUMBERPLATE_PATTERN: /^.{1,100}$/,
}
